import { ComponentCategory, CaseColor, ComponentOption } from "@/types/types";

const whiteColor: CaseColor = {
  id: "color-white",
  name: "White",
  hexCode: "#FFFFFF",
  price: 0
};

const blackColor: CaseColor = {
  id: "color-black",
  name: "Black",
  hexCode: "#000000",
  price: 0
};
const graphiteColor: CaseColor = {
  id: "color-graphite",
  name: "Graphite",
  hexCode: "#41424C",
  price: 0
};
const jadeColor: CaseColor = {
  id: "color-jade",
  name: "Jade",
  hexCode: "#96b097",
  price: 0
};

const silverColor: CaseColor = {
  id: "color-silver",
  name: "Silver",
  hexCode: "#c0c0c0",
  price: 0
};

const redColor: CaseColor = {
  id: "color-red",
  name: "Red",
  hexCode: "#FF0000",
  price: 0
};
const pinkColor: CaseColor = {
  id: "color-pink",
  name: "Pink",
  hexCode: "#FFC0CB",
  price: 0
};
const yellowColor: CaseColor = {
  id: "color-yellow",
  name: "Yellow",
  hexCode: "#FFFF00",
  price: 0
};
const peachColor: CaseColor = {
  id: "color-peach",
  name: "Peach",
  hexCode: "#FFD7BE",
  price: 0
};
const turquoiseColor: CaseColor = {
  id: "color-turquoise",
  name: "Turquoise",
  hexCode: "#1ABC9C",
  price: 0
};

const baseCases: ComponentOption[] = [
  {
    id: "case-1",
    name: "NZXT H510",
    brand: "NZXT",
    price: 100,
    amazonLink: "https://amzn.to/42DOPlO",
    specs: {
      type: "Mid Tower",
      material: "Steel, Tempered Glass",
      dimensions: "16.93 x 8.86 x 18.31 inches",
      weight: "15.7 lb",
      formFactor: "ATX, Micro-ATX"
    },
    imageUrl: "https://xyhebqsgccwvmigqkwam.supabase.co/storage/v1/object/public/product-images//51wAv5q4adL._AC_SL1000_%20(1).webp",
    colorOptions: [whiteColor, blackColor],
    fanSlots: 4,
    preInstalledFans: 2,
    modelPath: 'https://jwfdegyprceomfuaoeow.supabase.co/storage/v1/object/public/models/case.glb',
    scale: [1, 1, 1],
    // NOTE: The positions below are placeholders. You must update them with the
    // actual coordinates from your 3D model's fan mount empties.
    sockets: [
      { name: 'SOCKET_FAN_MOUNT_1', position: [0, 0.15, 0.2] }, // Front Top
      { name: 'SOCKET_FAN_MOUNT_2', position: [0, -0.15, 0.2] },// Front Bottom
      { name: 'SOCKET_FAN_MOUNT_3', position: [0.15, 0.2, 0] }, // Top
      { name: 'SOCKET_FAN_MOUNT_4', position: [-0.15, 0.2, 0] }, // Rear
      // NOTE: The positions below are placeholders. You must update them with the
      // actual coordinates from your 3D model's drive bay empties.
      { name: 'SOCKET_STORAGE_2.5IN_1', position: [0.1, -0.2, -0.1] },
      { name: 'SOCKET_STORAGE_2.5IN_2', position: [0.1, -0.25, -0.1] },
      { name: 'SOCKET_STORAGE_3.5IN_1', position: [0.1, -0.35, -0.1] },
    ],
  },
  {
    id: "case-2",
    name: "CORSAIR 4000D RS ARGB",
    brand: "Corsair",
    price: 115,
    amazonLink: "https://amzn.to/42sUAnI",
    specs: {
      type: "Mid Tower",
      material: "Steel, Tempered Glass",
      dimensions: "18.04 pounds",
      weight: "18.04 lb",
      formFactor: "ATX, Micro-ATX"
    },
    imageUrl: "https://xyhebqsgccwvmigqkwam.supabase.co/storage/v1/object/public/product-images//61-u3G8Bg9L._AC_SL1100_%20(2).webp",
    colorOptions: [whiteColor, blackColor],
    fanSlots: 7,
    preInstalledFans: 3,
  },
  {
    id: "case-3",
    name: "Lian Li O11 Dynamic EVO",
    brand: "Lian Li",
    price: 276,
    amazonLink: "https://amzn.to/4k4nII1",
    specs: {
      type: "Mid Tower",
      material: "Aluminum, Tempered Glass",
      dimensions: "18.31 x 11.22 x 18.07 IN",
      weight: "35.2 lb",
      formFactor: "ATX"
    },
    imageUrl: "https://xyhebqsgccwvmigqkwam.supabase.co/storage/v1/object/public/product-images//617EO7rVz9L._AC_SL1386_.webp",
    colorOptions: [whiteColor, blackColor],
    fanSlots: 7,
    preInstalledFans: 0,
  },
  {
    id: "case-4",
    name: "HYTE Revolt 3",
    brand: "HYTE",
    price: 135,
    amazonLink: "https://amzn.to/4cT4Fhl",
    specs: {
      type: "SFF",
      material: "Steel",
      dimensions: "9.9 x 7 x 16.1 in",
      weight: "11 kg",
      formFactor: "Mini-ITX"
    },
    imageUrl: "https://xyhebqsgccwvmigqkwam.supabase.co/storage/v1/object/public/product-images//61BX1bcjxYL._AC_SL1200_%20(1).webp",
    colorOptions: [blackColor, whiteColor],
    fanSlots: 4,
    preInstalledFans: 0,
  },
  {
    id: "case-5",
    name: "Fractal Design Terra",
    brand: "Fractal Design",
    price: 185,
    amazonLink: "https://amzn.to/3Yhzjel",
    specs: {
      type: "SFF",
      material: "Steel",
      dimensions: "13.5 x 6 x 8.6 in",
      weight: "11 kg",
      formFactor: "Mini-ITX"
    },
    imageUrl: "https://xyhebqsgccwvmigqkwam.supabase.co/storage/v1/object/public/product-images//71H5R3GsfsL._AC_SL1500_.webp",
    colorOptions: [graphiteColor, silverColor,jadeColor],
    fanSlots: 5,
    preInstalledFans: 1,
  },
  {
    id: "case-6",
    name: "DLM 21",
    brand: "Dark Flash",
    price: 73,
    amazonLink: "https://amzn.to/3YKeOXK",
    specs: {
      type: "Micro-ATX",
      material: "Steel",
      dimensions: "13.78 x 8.27 x 15.43 in",
      weight: "9.7 lb",
      formFactor: "Micro-ATX,Mini-ITX"
    },
    imageUrl: "",
    colorOptions: [blackColor, whiteColor],
    fanSlots: 5,
    preInstalledFans: 3,
  },
  {
    id: "case-7",
    name: "Aqua 3",
    brand: "Okinos",
    price: 73,
    amazonLink: "https://amzn.to/3YKeOXK",
    specs: {
      type: "Micro-ATX",
      material: "Steel",
      dimensions: "13.78 x 8.27 x 15.43 in",
      weight: "9.7 lb",
      formFactor: "Micro-ATX,Mini-ITX"
    },
    imageUrl: "",
    colorOptions: [blackColor, whiteColor],
    fanSlots: 7,
    preInstalledFans: 4,
  },
  {
    id: "case-8",
    name: "AIR 100 ",
    brand: "Montech",
    price: 73,
    amazonLink: "https://amzn.to/3YKeOXK",
    specs: {
      type: "Micro-ATX",
      material: "Steel",
      dimensions: "13.78 x 8.27 x 15.43 in",
      weight: "9.7 lb",
      formFactor: "Micro-ATX,Mini-ITX"
    },
    imageUrl: "",
    colorOptions: [blackColor, whiteColor],
    fanSlots: 7,
    preInstalledFans: 4,
  },
  {
    id: "case-9",
    name: "A3 - Wood Front Solid Side",
    brand: "Lian Li",
    price: 100,
    amazonLink: "https://amzn.to/42OgDE6",
    specs: {
      type: "Micro-ATX",
      material: "Steel, Wood",
      dimensions: "13.78 x 8.27 x 15.43 in",
      weight: "9.7 lb",
      formFactor: "Micro-ATX,Mini-ITX"
    },
    imageUrl: "",
    colorOptions: [blackColor, whiteColor],
    fanSlots: 7,
    preInstalledFans: 0,
  },
  {
    id: "case-10",
    name: "A3 - Wood Front Glass Side",
    brand: "Lian Li",
    price: 100,
    amazonLink: "https://amzn.to/42OgDE6",
    specs: {
      type: "Micro-ATX",
      material: "Steel, Tempered Glass, Wood",
      dimensions: "13.78 x 8.27 x 15.43 in",
      weight: "9.7 lb",
      formFactor: "Micro-ATX,Mini-ITX"
    },
    imageUrl: "https://xyhebqsgccwvmigqkwam.supabase.co/storage/v1/object/public/product-images//81hUyRq-RL._AC_SL1500_.webp",
    colorOptions: [blackColor, whiteColor],
    fanSlots: 7,
    preInstalledFans: 0,
  },
  {
    id: "case-11",
    name: "A3 - Wood Front Solid Side",
    brand: "Lian Li",
    price: 100,
    amazonLink: "https://amzn.to/42OgDE6",
    specs: {
      type: "Micro-ATX",
      material: "Steel, Wood",
      dimensions: "13.78 x 8.27 x 15.43 in",
      weight: "9.7 lb",
      formFactor: "Micro-ATX,Mini-ITX"
    },
    imageUrl: "https://xyhebqsgccwvmigqkwam.supabase.co/storage/v1/object/public/product-images//71H5R3GsfsL._AC_SL1500_.webp",
    colorOptions: [blackColor, whiteColor],
    fanSlots: 7,
    preInstalledFans: 0,
  },
  {
    id: "case-12",
    name: "Thermaltake Tower 300",
    brand: "Thermaltake",
    price: 175,
    amazonLink: "https://amzn.to/3TqgT89",
    specs: {
      type: "Micro-ATX",
      material: "Steel",
      dimensions: "13.78 x 8.27 x 15.43 in",
      weight: "9.7 lb",
      formFactor: "Micro-ATX,Mini-ITX"
    },
    imageUrl: "https://xyhebqsgccwvmigqkwam.supabase.co/storage/v1/object/public/product-images//71i3nrxnW8L._AC_SL1500__11zon.avif",
    colorOptions: [blackColor, whiteColor, pinkColor,yellowColor,peachColor,turquoiseColor],
    fanSlots: 4,
    preInstalledFans: 1,
  },
  {
    id: "case-13",
    name: "XR",
    brand: "Montech",
    price: 76,
    amazonLink: "https://amzn.to/4jSuAYa",
    specs: {
      type: "ATX",
      material: "Steel",
      dimensions: "13.78 x 8.27 x 15.43 in",
      weight: "9.7 lb",
      formFactor: "ATX"
    },
    imageUrl: "https://xyhebqsgccwvmigqkwam.supabase.co/storage/v1/object/public/product-images//81HNlMMbZbL._AC_SL1500_.avif",
    colorOptions: [blackColor, whiteColor],
    fanSlots: 9,
    preInstalledFans: 3,
  },
  {
    id: "case-14",
    name: "Meshify",
    brand: "Fractical Design",
    price: 150,
    amazonLink: "https://amzn.to/4jSuAYa",
    specs: {
      type: "ATX",
      material: "Steel",
      dimensions: "13.78 x 8.27 x 15.43 in",
      weight: "9.7 lb",
      formFactor: "ATX"
    },
    imageUrl: "https://xyhebqsgccwvmigqkwam.supabase.co/storage/v1/object/public/product-images//81nqpH8jbbL._AC_SL1500_.avif",
    colorOptions: [blackColor, whiteColor],
    fanSlots: 9,
    preInstalledFans: 3,
    modelPath: 'https://xyhebqsgccwvmigqkwam.supabase.co/storage/v1/object/public/models//compressed_1750392285429_fractal_design._meshify_c__-__pc_case.glb',
  }
];

export const caseComponents: ComponentCategory = {
  id: "case",
  name: "Case",
  description: "The enclosure that houses all your components.",
  required: true,
  options: baseCases,
};
